import { wbp, reduceResolution } from 'Theme';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useSingleSaleTableItemStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {},
        gridContainer: {
            'width': '100%',
            'borderRadius': 16,
            'overflow': 'visible',

            '&:last-child': {
                marginBottom: 16
            },

            [theme.breakpoints.down('md')]: {
                padding: 16,
                border: 'solid 1px #D4D4D4'
            },
            [theme.breakpoints.up('lg')]: {
                alignItems: 'center',
                boxShadow:
                    '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)'
            }
        },
        gridCellName: {
            overflow: 'visible',
            [theme.breakpoints.down(wbp)]: {
                padding: `${reduceResolution(19)}px 28px`
            },
            [theme.breakpoints.up(wbp)]: {
                padding: '19px 28px'
            }
        },
        cellCenter: {
            textAlign: 'center'
        },
        closeIcon: {
            cursor: 'pointer',
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(24)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '24px'
            }
        },
        deleteSpinner: {
            width: '24px'
        },
        deleteSpinnerCircular: {
            width: '18px !important',
            height: '18px !important'
        },
        spinner: {
            [theme.breakpoints.down(wbp)]: {
                marginTop: '12px'
            },
            [theme.breakpoints.up(wbp)]: {
                marginTop: '15px'
            }
        },
        errorBackground: {
            backgroundColor: 'rgba(250,0,0,0.15)'
        },

        field: {
            width: 150,

            [theme.breakpoints.down('md')]: {
                '& input': {
                    height: 36,
                    paddingTop: 0,
                    paddingBottom: 0
                },
                '& input, & .MuiTypography-root': {
                    fontSize: 14,
                    textAlign: 'left'
                },
                '& .MuiInputAdornment-positionStart': {
                    paddingLeft: 0
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    top: -6
                }
            },
            [theme.breakpoints.up('lg')]: {
                width: 200
            }
        },
        individualFieldPrice: {
            width: 120
        },
        gridCenter: {
            display: 'flex',
            justifyContent: 'center'
        },

        boxCell: {
            width: '100%'
        },

        // mobile
        mobileGridHeader: {
            gap: 12,
            display: 'grid',
            paddingBottom: 16,
            borderBottom: 'solid 1px #D4D4D4'
        },
        mobilePrice: {
            fontSize: 15,
            lineHeight: 1,
            fontWeight: 500
        },
        mobileDescription: {
            fontSize: 15,
            lineHeight: 1.2,
            fontWeight: 500,
            display: 'block',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        },
        mobileGridTwoColumns: {
            gap: 16,
            display: 'grid',
            alignItems: 'center',
            gridTemplateColumns: '1fr minmax(min-content, auto)'
        },
        mobileGridTable: {
            'gap': 4,
            'display': 'flex',
            'flexWrap': 'wrap',
            'paddingTop': 12,
            'paddingBottom': 12,

            '& > *': {
                width: '100%'
            }
        },
        mobileGridRow: {
            minHeight: 36
        },
        mobileGridTableLabel: {
            fontSize: 14,
            lineHeight: 1
        },
        mobileGridFooter: {
            paddingTop: 12,
            borderTop: 'solid 1px #D4D4D4'
        },
        mobileDeleteButton: {
            'gap': 4,
            'border': 0,
            'padding': 0,
            'color': '#EF4F57',
            'fontSize': 14,
            'lineHeight': 1,
            'fontWeight': 500,
            'paddingBottom': 7,
            'display': 'inline-flex',
            'alignItems': 'center',
            'backgroundColor': 'transparent',
            'borderBottom': 'solid 2px #EF4F57',

            '&:disabled': {
                cursor: 'default',
                opacity: 0.7
            },

            '& svg': {
                fontSize: 14
            }
        }
    })
);
